import React from 'react'

import Layout from '../components/layout'
import styling from "../styles/style.module.css"

export default ({ data }) => (
  <Layout>
    <div className={styling.fade_in}>
      <h1>
        Hello! My name is Eric Sun and this is my personal website!
      </h1>

      <p>
        I'm a rising senior at Cornell University majoring in CS and Statistics (2020).
      </p>
      <p>
        At Cornell, I'm involved in the Cornell Data Science project team. I work on the Insights team
        where we focus primarily on Data Visualization (D3) and Machine Learning (python, sklearn). 
      </p>
      <p>
        I was also involved as a TA at Cornell. I predominantly acted as a TA for statistics and information science courses.
      </p>
      <p>
        I'm interested in SWE, data science, and data visualization. I primarily work with python, 
        java, and javascript.
      </p>
      <p>
        Outside of school I enjoy fencing, playing soccer, and board games. I love music and am always looking to expand
        my massive playlist of generic pop, indie, hip hop, and country music that isn't really country.
      </p>
    </div>
  </Layout>
)